export function isString(value: any): boolean {
  return Object.prototype.toString.call(value) === '[object String]';
}


export function downloadFile(fileName: string, fileType: string, content: string ) {
  let blob = new Blob([content], {type: fileType});

  if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, fileName);
  } else {
      let elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = fileName;        
      document.body.appendChild(elem)
      elem.click();        
      document.body.removeChild(elem);
  }
}

export function downloadCsv(fileName: string, content: string) {
  downloadFile(fileName, 'text/csv', content);
}


// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-converters/util.ts